window.trackedVimeoVideos = [];

/**
 * Play.
 *
 * @param {object} player
 *   The vimeo player object.
 * @param {object} data
 *   The event data.
 */
const onVimeoPlay = (player, data) => {
  // Check if video already played.
  player.getVideoTitle().then((title) => {
    const foundVideoIndex = window.trackedVimeoVideos.findIndex((video) => video.title === title);

    // New video.
    let foundVideo = {};
    if (foundVideoIndex === -1) {
      foundVideo = {
        title,
        play: false,
        end: false,
        progress: [],
      };

      foundVideo.play = true;
      window.trackedVimeoVideos = [...window.trackedVimeoVideos, foundVideo];
      window.dataLayer.push({
        event: 'custom.vimeoTrack',
        'custom.videoAction': 'play',
        'custom.videoName': title,
      });
    } else {
      foundVideo = window.trackedVimeoVideos[foundVideoIndex];
      if (!foundVideo.play) {
        foundVideo.play = true;
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'custom.vimeoTrack',
            'custom.videoAction': 'play',
            'custom.videoName': title,
          });
        }
      }
      window.trackedVimeoVideos = [...window.trackedVimeoVideos.slice(0, foundVideoIndex), foundVideo, ...window.trackedVimeoVideos.slice(foundVideoIndex + 1)];
    }
  });
};

/**
 * Progress.
 *
 * @param {object} player
 *   The vimeo player object.
 * @param {object} data
 *   The event data.
 */
const onVimeoTimeUpdate = (player, data) => {
  player.getVideoTitle().then((title) => {
    const progress = parseInt(data.percent * 100, 10);
    const foundVideoIndex = window.trackedVimeoVideos.findIndex((video) => video.title === title);
    let logProgress = false;

    // New video.
    let foundVideo = {};
    if (foundVideoIndex === -1) {
      foundVideo = {
        title,
        play: false,
        end: false,
        progress: [],
      };

      if (progress >= 25 && foundVideo.progress.indexOf(25) === -1) {
        foundVideo.progress.push(25);
        logProgress = 25;
      } else if (progress >= 50 && foundVideo.progress.indexOf(50) === -1) {
        foundVideo.progress.push(50);
        logProgress = 50;
      } else if (progress >= 75 && foundVideo.progress.indexOf(75) === -1) {
        foundVideo.progress.push(75);
        logProgress = 75;
      }
      window.trackedVimeoVideos = [...window.trackedVimeoVideos, foundVideo];
    } else {
      foundVideo = window.trackedVimeoVideos[foundVideoIndex];
      if (progress >= 25 && foundVideo.progress.indexOf(25) === -1) {
        foundVideo.progress.push(25);
        logProgress = 25;
      } else if (progress >= 50 && foundVideo.progress.indexOf(50) === -1) {
        foundVideo.progress.push(50);
        logProgress = 50;
      } else if (progress >= 75 && foundVideo.progress.indexOf(75) === -1) {
        foundVideo.progress.push(75);
        logProgress = 75;
      }
      window.trackedVimeoVideos = [...window.trackedVimeoVideos.slice(0, foundVideoIndex), foundVideo, ...window.trackedVimeoVideos.slice(foundVideoIndex + 1)];
    }

    if (logProgress !== false) {
      window.dataLayer.push({
        event: 'custom.vimeoTrack',
        'custom.videoAction': `${logProgress}%`,
        'custom.videoName': title,
      });
    }
  });
};

/**
 * End.
 *
 * @param {object} player
 *   The vimeo player object.
 * @param {object} data
 *   The event data.
 */
const onVimeoEnd = (player, data) => {
  player.getVideoTitle().then((title) => {
    const foundVideoIndex = window.trackedVimeoVideos.findIndex((video) => video.title === title);

    // New video.
    let foundVideo = {};
    if (foundVideoIndex === -1) {
      foundVideo = {
        title,
        play: false,
        end: false,
        progress: [],
      };

      foundVideo.end = true;
      window.trackedVimeoVideos = [...window.trackedVimeoVideos, foundVideo];
      window.dataLayer.push({
        event: 'custom.vimeoTrack',
        'custom.videoAction': 'end',
        'custom.videoName': title,
      });
    } else {
      foundVideo = window.trackedVimeoVideos[foundVideoIndex];
      if (!foundVideo.end) {
        foundVideo.end = true;
        window.dataLayer.push({
          event: 'custom.vimeoTrack',
          'custom.videoAction': 'end',
          'custom.videoName': title,
        });
      }
      window.trackedVimeoVideos = [...window.trackedVimeoVideos.slice(0, foundVideoIndex), foundVideo, ...window.trackedVimeoVideos.slice(foundVideoIndex + 1)];
    }
  });
};

export { onVimeoPlay, onVimeoTimeUpdate, onVimeoEnd };
